// components/AppNav.js
//
// Gedeelde navigatiebalk (computer/tablet) voor verhuurder en schoonmaker, in de
// huisstijl: logo links, pilknoppen in het midden, bel en profiel rechts. Op een
// telefoon gebruiken beide dashboards de onderste tabbalk van de app i.p.v. deze
// balk (zie useAppLayout in utils/nativeApp).
//
// items: [{ key, label, active, onClick, badge? }]
import React from 'react';
import SmartStaysLogo from './SmartStaysLogo';
import './AppNav.css';

function AppNav({ items, right }) {
  return (
    <nav className="app-nav">
      <div className="app-nav-inner">
        <div className="app-nav-brand">
          <SmartStaysLogo className="nav-logo" />
        </div>

        <div className="app-nav-links">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`app-nav-link ${item.active ? 'active' : ''}`}
              aria-current={item.active ? 'page' : undefined}
              onClick={item.onClick}
            >
              {item.label}
              {item.badge > 0 && <span className="app-nav-badge">{item.badge}</span>}
            </button>
          ))}
        </div>

        <div className="app-nav-user">{right}</div>
      </div>
    </nav>
  );
}

export default AppNav;
